var exports = {
  "k": "xdde3148b--dcd516--container",
  "p": "xdde3148b--dcd516--list",
};

module.exports = exports;
